import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { CircularProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { useCrops } from '../../../../adapters/crops';
import CropCard from './CropCard';
import CropFormDialog from './CropFormDialog';
import EmptyState from './EmptyState';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 600,
    },
    addButton: {
        borderRadius: theme.spacing(1),
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
    },
}));

export default function Crops({ parcel }) {
    const classes = useStyles();
    const { t } = useTranslation();

    const [crops, setCrops] = React.useState([]);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [selectedCrop, setSelectedCrop] = React.useState(null);

    const { data, refetch, isLoading } = useCrops(parcel);

    React.useEffect(() => {
        if (data) setCrops(data);
    }, [data]);

    React.useEffect(() => {
        refetch();
    }, [parcel, refetch]);

    const handleAddClick = () => {
        setSelectedCrop(null);
        setDialogOpen(true);
    };

    const handleEditClick = (crop) => {
        setSelectedCrop(crop);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setSelectedCrop(null);
    };

    if (isLoading) {
        return (
            <Box className={classes.loadingContainer}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box className={classes.root}>
            <Box className={classes.header}>
                <Typography variant="h5" className={classes.title}>
                    {t('Crop_rotation')}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleAddClick}
                    className={classes.addButton}
                >
                    {t('Add Crop')}
                </Button>
            </Box>

            {crops.length === 0 ? (
                <EmptyState onAddClick={handleAddClick} />
            ) : (
                <Grid container spacing={3}>
                    {crops.map((crop) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={crop.id}>
                            <CropCard
                                crop={crop}
                                onEdit={handleEditClick}
                                refetch={refetch}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}

            <CropFormDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                crop={selectedCrop}
                parcel={parcel}
                refetch={refetch}
            />
        </Box>
    );
}
